// The legacy build: the default one calls Promise.withResolvers inside the worker, where no polyfill
// reaches, so PDFs fail to render on Safari/iOS before 17.4. Every pdfjs-dist import must use this
// same entry, or GlobalWorkerOptions is a different module instance.
import { getDocument, GlobalWorkerOptions, version } from 'pdfjs-dist/legacy/build/pdf.mjs';

type PdfDocumentSource = Exclude<Parameters<typeof getDocument>[0], string | URL | ArrayBuffer | ArrayBufferView>;

/**
 * Points pdf.js at the worker copied out of node_modules by scripts/copy-pdfjs-worker.js.
 * The URL carries the installed version because app.yaml serves every *.js immutable for a
 * year — a fixed path would pair a new bundle with the previously cached worker, and pdf.js
 * rejects that mismatch.
 */
export function configurePdfJsWorker(): void {
  GlobalWorkerOptions.workerSrc = `assets/libs/pdf.worker.legacy.${version}.min.js`;
}

/**
 * The only way the app parses a PDF. Owning isEvalSupported here keeps the CVE-2024-4367 glyph
 * path off for every call site, including ones added later.
 */
export function loadPdfDocument(source: PdfDocumentSource) {
  return getDocument({ ...source, isEvalSupported: false });
}
